<template>
  <v-dialog v-model="dialog" max-width="440" persistent>
    <v-card>

      <!-- Header -->
      <div style="background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; gap: 12px;">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="rgba(255,255,255,0.15)" size="38">
            <v-icon color="white" size="20">mdi-calendar-edit</v-icon>
          </v-avatar>
          <div>
            <div style="font-size: 1rem; font-weight: 700; color: #fff;">Actualizar Fechas del Módulo</div>
            <div style="font-size: 0.75rem; color: rgba(255,255,255,0.65);">Módulo #{{ input.numero }}</div>
          </div>
        </div>
        <v-btn icon dark small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-5 pb-2 px-5">
        <v-row dense>
          <v-col cols="12" sm="6">
            <FechaMod ref="refFechaMod1" label="Fecha inicio"
              v-on:select="input.fecha_inicio = $event"
              :valor="input.fecha_inicio" />
          </v-col>
          <v-col cols="12" sm="6">
            <FechaMod ref="refFechaMod2" label="Fecha fin"
              v-on:select="input.fecha_fin = $event"
              :valor="input.fecha_fin" />
          </v-col>
        </v-row>
        <v-progress-linear v-if="loading" indeterminate height="2" color="indigo lighten-3" class="mt-3" />
      </v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer />
        <v-btn text @click="dialog = false" :disabled="loading">Cancelar</v-btn>
        <v-btn color="indigo darken-1" dark depressed :loading="loading" @click="guardar">
          <v-icon left small>mdi-check</v-icon> Actualizar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import FechaMod from './edit_mod_fecha.vue';
import axios from '@/xaxios';

export default {
  components: { FechaMod },
  emits: ['onsuccess'],
  data() {
    return {
      api_rest: process.env.VUE_APP_API_REST,
      dialog: false,
      loading: false,
      input: {
        programa_modulo_id: null,
        modulo_id: null,
        docente_id: null,
        numero: null,
        fecha_inicio: null,
        fecha_fin: null,
        estado: null,
      },
    };
  },
  methods: {
    openDialog(item) {
      this.input.programa_modulo_id = item.id;
      this.input.modulo_id = item.idmodulo;
      this.input.docente_id = item.iddocente;
      this.input.numero = item.numero;
      this.input.fecha_inicio = item.inicio;
      this.input.fecha_fin = item.fin;
      this.input.estado = item.estado;
      this.dialog = true;
      const vue = this;
      setTimeout(() => {
        vue.$refs.refFechaMod1.set(item.inicio);
        vue.$refs.refFechaMod2.set(item.fin);
      }, 200);
    },
    parseFecha(d) {
      if (!d) return d;
      const fs = (d + '').split('-');
      return `${fs[2]}/${fs[1]}/${fs[0]}`;
    },
    async guardar() {
      const data = {
        id: this.input.programa_modulo_id,
        fecha_inicio: this.parseFecha(this.input.fecha_inicio),
        fecha_fin: this.parseFecha(this.input.fecha_fin),
      };
      this.loading = true;
      const url = this.api_rest + '/api/v1/esam/programa/modulo/date';
      const res = await axios.put(url, data).then(d => d).catch(e => e);
      if (res && res.response) {
        this.$root.$notify.show(res.response.data.errors, { color: 'red', x: 'right' });
      } else if (res && res.data) {
        this.$emit('onsuccess', data);
        this.$root.$notify.show(res.data.data, { color: 'success', x: 'right' });
        this.dialog = false;
      }
      this.loading = false;
    },
  },
};
</script>
